import { IconButton, Modal } from "@mui/material";

import React, { useState } from "react";
import * as SVGIcons from "../../../../../../assets/iconsSVG";
import { Atendimentos } from "../../../../../../interfaces";
import FormEditAtendimento from "../FormEditAtendimento";
import * as Styles from "./styles";
import CustomTooltip from "../../../../../../components/CustomTooltip/CustomToolTip.component";

interface Props {
  data: Atendimentos;
  refetch: () => void;
}

const TableItem: React.FC<Props> = ({ data, refetch }) => {
  const [openEditModal, setOpenEditModal] = useState(false);
  return (
    <Styles.Container>
      <Styles.Cell>
        <CustomTooltip title={<p>{data?.nomeLead ? data?.nomeLead : "--"}</p>}>
          <Styles.CellText>
            {data?.nomeLead ? data?.nomeLead : "--"}
          </Styles.CellText>
        </CustomTooltip>
      </Styles.Cell>
      <Styles.Cell>
        <CustomTooltip
          title={
            <>
              <p>Corretor: {data?.nomeCorretor ? data?.nomeCorretor : "--"}</p>
              <p>
                Empresa de vendas:{" "}
                {data?.empresaVenda ? data?.empresaVenda : "--"}
              </p>
              <p>Equipe: {data?.equipe ? data?.equipe : "--"}</p>
            </>
          }
        >
          <Styles.CellText>
            {data?.nomeCorretor ? data?.nomeCorretor : "--"}
          </Styles.CellText>
        </CustomTooltip>
      </Styles.Cell>
      <Styles.Cell>
        <CustomTooltip
          title={<p>{data?.tipoAtendimento ? data?.tipoAtendimento : "--"}</p>}
        >
          <Styles.CellText>
            {data?.tipoAtendimento ? data?.tipoAtendimento : "--"}
          </Styles.CellText>
        </CustomTooltip>
      </Styles.Cell>
      <Styles.Row>
        <Styles.CellDate>
          <Styles.CellText>{data?.dataHoraVisita}</Styles.CellText>
        </Styles.CellDate>
        <Styles.CellSmall>
          <IconButton
            onClick={() => setOpenEditModal(true)}
            style={{
              borderRadius: 4,
              backgroundColor: "#D5DEFF",
              marginLeft: "3px",
            }}
            aria-label="add"
          >
            <SVGIcons.EdiCallsIcon />
          </IconButton>
        </Styles.CellSmall>
      </Styles.Row>
      <Modal open={openEditModal} onClose={() => setOpenEditModal(false)}>
        <FormEditAtendimento
          data={data}
          closeModal={() => setOpenEditModal(false)}
          refresh={() => refetch()}
        />
      </Modal>
    </Styles.Container>
  );
};

export default TableItem;
